<template>
  <div>
    <header>
      <van-sticky>
        <van-nav-bar title="StarPay" />
      </van-sticky>
    </header>
    <main>
      <router-view/>
    </main>
    <footer>
      <van-tabbar route>
        <van-tabbar-item to="/" icon="point-gift-o">{{ $t('product.title') }}</van-tabbar-item>
        <van-tabbar-item to="/shoppingcart" icon="shopping-cart-o" :badge="cartProductCount">{{ $t('shoppingcart.title') }}</van-tabbar-item>
        <van-tabbar-item to="/order" icon="description" :badge="orderCount">{{ $t('order.title') }}</van-tabbar-item>
        <van-tabbar-item to="/center" icon="user-o">{{ $t('user.title') }}</van-tabbar-item>
      </van-tabbar>
    </footer>
  </div>
</template>

<script>
import { getProductCount } from '@/api/shoppingcart'
import { countNeedPay } from '@/api/order'

export default {
  data() {
    return {
      cartProductCount: '',
      orderCount: '',
    }
  },
  created() {
    this.fetchCartProductCount()
    this.fetchOrderCount()
  },
  methods: {
    fetchCartProductCount() {
      getProductCount().then(rep => {
        this.cartProductCount = rep.data.count > 0 ? rep.data.count : ''
      })
    },
    fetchOrderCount() {
      countNeedPay().then(rep => {
        this.orderCount = rep.data > 0 ? rep.data : ''
      })
    }
  }
}
</script>

<style>
</style>